import React, { ReactNode } from 'react';
import { Stack } from '@mui/material';
import styles from './ElementData.styles';

export type ElementDataContainerSize = 'small' | 'medium';
interface ElementDataContainerProps {
    children: ReactNode;
    size?: ElementDataContainerSize;
    showHeader?: boolean;
    viewMods?: string[];
}
export default function ElementDataContainer(props: ElementDataContainerProps) {
    const { children, size = 'small', showHeader = true, viewMods = [] } = props;

    return (
        <Stack
            sx={styles.container}
            className={`
                element-data-container 
                element-data-container--size-${size} 
                element-data-container--headers-${showHeader ? 'show' : 'hide'} 
                ${viewMods.map((mod) => 'element-data-container--mod-' + mod)}
            `}
        >
            {children}
        </Stack>
    );
}
